import React, { useEffect, useState } from 'react';
import { Button, Form, Modal, Segment } from 'semantic-ui-react';
import HotelsDropDown from '../../components/shared/HotelsDropDown';
import { onError, onWarning } from '../../components/shared/messages';
import Panel from '../../components/shared/Panel';
import { useTextResources } from '../../language';
import PropTypes from "prop-types";
import { Rates } from '../../api/services/next';
import { useCurrentHotel } from '../../hooks/useCurrentHotel';
import { useLoader } from '../../hooks/useLoader';
import { endpoint } from '../../api/http'
import { RateCategoriesOrder } from '../../components/shared/constants';


export const PriceListCategorySelectionPopup = ({ open, onCancelChanges }) => {
    const loader = useLoader()
    const text = useTextResources();
    const [hotelId, setHotelId] = useState(null);
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        (async () => {
            try {
                let fetchedCategories = await Rates.GetRateCategories();
                setCategories(fetchedCategories);
            } catch (error) {
                onError(error)
            }
        })();
    }, [])

    const closeHandler = () => {
        setHotelId(null);
        onCancelChanges?.()
    }

    const createInitialRate = async (category) => {
        if (hotelId) {
            const currentDate = new Date();
            const newRate = {
                Name: `New Rate(${category.Name}) - ${currentDate.toLocaleDateString()}`,
                HotelId: hotelId,
                RateCategoryID: category.Id,
                StartDate: new Date(),
                EndDate: new Date(currentDate.setFullYear(currentDate.getFullYear() + 1)),
                TypeId: 2,
                IsSystemRate: false,
                IsRateAssignedToAllCustomers: false,
                IsDayUse: false,
                IsDistributeToChannelManager: false,
                IsDefaultRateForReservation: false,
                IsProductPricingIncludesTax: false,
                IsRateAssignedToAllReservationGroups: false,
                ConsiderLiveMinMaxNights: true,
                IsActive: false,
                CurrencyId: useCurrentHotel.MainCurrencyId
            }

            try {
                loader(true);
                const createdRate = await Rates.PostRate(newRate);
                window.location.href = `${endpoint}/PMS/pricelist/Edit?RateId=${createdRate.Id}`;
            } catch (error) {
                onError(error);
            } finally {
                loader(false)
            }
        }
        else
            onWarning(text("SelectHotel"));
    }

    return <Modal open={open} onClose={closeHandler} scrolling>
        <Modal.Header style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            {`${text("Create")} ${text("PriceList")}`}
        </Modal.Header>
        <Modal.Content className="modal-content-scrollable">
            <Form>
                <Segment vertical style={{position: 'sticky', top: '-21px', zIndex: '10', background: '#fff'}}>
                    <Form.Field label={text("Hotel")} control={HotelsDropDown} onChange={setHotelId} value={hotelId} />
                </Segment>
                {categories
                    .filter(x => RateCategoriesOrder.includes(x.Id))
                    .sort((a,b) => RateCategoriesOrder.indexOf(a.Id) < RateCategoriesOrder.indexOf(b.Id)? -1: 1)
                    .map((category, categoryIndex) => <Panel key={categoryIndex} header={text(category.Name)}>
                        <div>
                            {text(category.Description)}
                        </div>
                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                            <Button onClick={() => createInitialRate(category)}>{text("Create")}</Button>
                        </div>
                </Panel>)}
            </Form>
        </Modal.Content>
    </Modal>
}

PriceListCategorySelectionPopup.propTypes = {
    open: PropTypes.bool,
    onCancelChanges: PropTypes.func,
};
